import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Button } from 'primereact/button';

import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';
import { createContact } from 'services/contact';
import { createVenue } from 'services/Settings';
import TextSnippetWrapper from 'components/TextSnippetWrapper';

export default function AddCourt(props) {
  const { onSuccess, onDismiss, isCourt } = props;
  const { handleSubmit, control } = useForm();
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);

  const _onDismiss = () => typeof onDismiss === 'function' && onDismiss();

  const handleAddCaseCourt = ({ name }) => {
    if (name) {
      setLoading(true);
      let data = {};
      data = {
        phone: '',
        title: name,
        contact_type: 'location',
        is_court_location: true,
        email: '',
        country_code: '+1',
      };
      createContact(data)
        .then((response) => {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.CASE_COURT_CREATED);
          setLoading(false);
          typeof onSuccess === 'function' && onSuccess(response.data);
        })
        .catch((error) => {
          if (error?.response?.data) {
            addToast(false, toastConstant.toasterType.WARN, toastConstant.api.FAILED, error.response.data);
          }
          setLoading(false);
        });
    } else {
      addToast(false, toastConstant.toasterType.INFO, toastConstant.api.FAILED, toastConstant.message.CASE_COURT_NAME_VALIDATION);
    }
  };

  const handleAddVenue = ({ name }) => {
    if (name) {
      setLoading(true);
      let data = {};
      data = {
        venue_name: name,
        // is_lead :false
      };
      createVenue(data)
        .then((response) => {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.VENUE_CREATED);
          setLoading(false);
          typeof onSuccess === 'function' && onSuccess(response.data);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            addToast(false, toastConstant.toasterType.WARN, toastConstant.api.FAILED, error.response.data);
          }
          setLoading(false);
        });
    } else {
      addToast(false, toastConstant.toasterType.INFO, toastConstant.api.FAILED, toastConstant.message.VENUE_NAME_VALIDATION);
    }
  };

  return (
    <div className="p-inputgroup align-items-center">
      <Controller
        name="name"
        control={control}
        render={({ field }) => <TextSnippetWrapper type="text" id={field.name} {...field} className="input-shadow w-100" />}
      />
      <Button
        icon="pi pi-check"
        className="p-button-secondary mx-2"
        type="button"
        onClick={isCourt ? handleSubmit(handleAddCaseCourt) : handleSubmit(handleAddVenue)}
        loading={loading}
      />
      <Button icon="pi pi-times" className="p-button-secondary outline" type="button" onClick={_onDismiss} disabled={loading} />
    </div>
  );
}
